import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Header.css"; // Your custom CSS
import host from "../config";
const Header = () => {
  const navigate = useNavigate();
  const [name, setName] = useState(null);
  const [locations, setLocations] = useState([]);

  const [isVenueDropdownOpen, setVenueDropdownOpen] = useState(false);
  const [userRole, setUserRole] = useState(
    localStorage.getItem("userRole") || "0"
  );

  useEffect(() => {
    const tokenInfo = localStorage.getItem("token-info");
    if (tokenInfo) {
      const user = JSON.parse(tokenInfo);
      setName(user.name);
    }
    const fetchLocations = async () => {
      try {
        const response = await fetch(`${host}/locations`);
        const data = await response.json();
        setLocations(data);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };
    fetchLocations();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token-info");
    localStorage.removeItem("userRole");
    localStorage.removeItem("access_token");
    localStorage.removeItem("bookingDetailsData");
    navigate("/Login", "_self");
  };

  const isLoggedIn = name !== null;

  return (
    <header>
      {/* Top Banner */}
      <div className="top-banner">
        <div className="logo-section">
          <Link to="/" className="logo-link">
            <img
              src="https://vmrdaprod-assests.s3.ap-south-1.amazonaws.com/VMRDA%20Logo.png"
              alt="VMRDA Logo"
              className="logo"
            />
          </Link>
        </div>

        <div className="logo-text" style={{ textAlign: "center" }}>
          Visakhapatnam Metropolitan Region Development Authority
        </div>

        <div className="auth-section">
          {isLoggedIn ? (
            <div className="welcome-dropdown">
              <span className="welcome-text">Welcome, {name}</span>
              <div className="dropdown">
                <button className="dropdown-btn">☰</button>
                <div className="dropdown-content">
                  {/* Dropdown for User Role 0 */}
                  {userRole === "0" && (
                    <>
                      {/* <Link to="/MyBookings" className="dropdown-item">
                        My Bookings
                      </Link> */}
                      <a
                        href="http://vmrda.gov.in/contactus.aspx"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="dropdown-item"
                      >
                        Contact
                      </a>

                      <div
                        className="dropdown-item venue-dropdown"
                        onMouseEnter={() => setVenueDropdownOpen(true)}
                        onMouseLeave={() => setVenueDropdownOpen(false)}
                      >
                        Venue Details ⬅
                        {isVenueDropdownOpen && (
                          <div className="sub-menu">
                            {" "}
                            {/* Now appears to the left */}
                            {locations.length > 0 ? (
                              locations.map((loc) => (
                                <Link
                                  key={loc.id}
                                  to={`/location/${loc.id}`}
                                  className="sub-menu-item"
                                >
                                  {loc.name}
                                </Link>
                              ))
                            ) : (
                              <div className="sub-menu-item">
                                No Locations Found
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                      <button className="dropdown-item" onClick={handleLogout}>
                        Logout
                      </button>
                    </>
                  )}

                  {userRole === "1" && (
                    <>
                      {/* <Link to="/" className="dropdown-item">
                        Accommodation
                      </Link> */}

                      <Link to="/MyBookings" className="dropdown-item">
                        All Bookings
                      </Link>
                      <Link to="/discount" className="dropdown-item">
                        Discount
                      </Link>

                      <Link to="/blocked-data" className="dropdown-item">
                        Blocked list
                      </Link>
                         <Link to="/Booked-Reports" className="dropdown-item">
                      Reports
                      </Link>

                      {/* <Link to="/user-blocked-data" className="dropdown-item">
                        User Blocked Data
                      </Link> */}
                      <div
                        className="dropdown-item venue-dropdown"
                        onMouseEnter={() => setVenueDropdownOpen(true)}
                        onMouseLeave={() => setVenueDropdownOpen(false)}
                      >
                        Venue Details ⬅
                        {isVenueDropdownOpen && (
                          <div className="sub-menu">
                            {" "}
                            
                            {locations.length > 0 ? (
                              locations.map((loc) => (
                                <Link
                                  key={loc.id}
                                  to={`/location/${loc.id}`}
                                  className="sub-menu-item"
                                >
                                  {loc.name}
                                </Link>
                              ))
                            ) : (
                              <div className="sub-menu-item">
                                No Locations Found
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                      <button className="dropdown-item" onClick={handleLogout}>
                        Logout
                      </button>
                    </>
                  )}

                  {userRole === "2" && (
                    <>
                      {/* <Link to="/" className="dropdown-item">
                        Accommodation
                      </Link> */}

                      <Link to="/MyBookings" className="dropdown-item">
                        All Bookings
                      </Link>
                      <Link to="/discount" className="dropdown-item">
                        Discount
                      </Link>
                      <Link to="/blocked-data" className="dropdown-item">
                        Blocked list
                      </Link>
                         <Link to="/Booked-Reports" className="dropdown-item">
                        Reports
                      </Link>

                      {/* <Link to="/user-blocked-data" className="dropdown-item">
                        User Blocked Data
                      </Link> */}
                      <div
                        className="dropdown-item venue-dropdown"
                        onMouseEnter={() => setVenueDropdownOpen(true)}
                        onMouseLeave={() => setVenueDropdownOpen(false)}
                      >
                        Venue Details ⬅
                        {isVenueDropdownOpen && (
                          <div className="sub-menu">
                            {" "}
                            {/* Now appears to the left */}
                            {locations.length > 0 ? (
                              locations.map((loc) => (
                                <Link
                                  key={loc.id}
                                  to={`/location/${loc.id}`}
                                  className="sub-menu-item"
                                >
                                  {loc.name}
                                </Link>
                              ))
                            ) : (
                              <div className="sub-menu-item">
                                No Locations Found
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                      <button className="dropdown-item" onClick={handleLogout}>
                        Logout
                      </button>
                    </>
                  )}
                  {userRole === "3" && (
                    <>
                      <Link to="/manage-venue" className="dropdown-item">
                        Manage Venue
                      </Link>
                      {/* <Link to="/" className="dropdown-item">
                        Accommodation
                      </Link> */}
                      

                      <Link to="/MyBookings" className="dropdown-item">
                        All Bookings
                      </Link>
                      <Link to="/Booked-Reports" className="dropdown-item">
                        Reports
                      </Link>
                      <div
                        className="dropdown-item venue-dropdown"
                        onMouseEnter={() => setVenueDropdownOpen(true)}
                        onMouseLeave={() => setVenueDropdownOpen(false)}
                      >
                        Venue Details ⬅
                        {isVenueDropdownOpen && (
                          <div className="sub-menu">
                            {" "}
                            {/* Now appears to the left */}
                            {locations.length > 0 ? (
                              locations.map((loc) => (
                                <Link
                                  key={loc.id}
                                  to={`/location/${loc.id}`}
                                  className="sub-menu-item"
                                >
                                  {loc.name}
                                </Link>
                              ))
                            ) : (
                              <div className="sub-menu-item">
                                No Locations Found
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                      <button className="dropdown-item" onClick={handleLogout}>
                        Logout
                      </button>
                    </>
                  )}

                  {userRole === "4" && (
                    <>
                      {/* <Link to="/" className="dropdown-item">
                        Accommodation
                      </Link> */}

                      <Link to="/AOBookings" className="dropdown-item">
                        All Bookings
                      </Link>
                       <Link to="/discount" className="dropdown-item">
                        Discount
                      </Link>

                      <Link to="/blocked-data" className="dropdown-item">
                        Blocked list
                      </Link>
                         <Link to="/Booked-Reports" className="dropdown-item">
                      Reports
                      </Link>

                      {/* <Link to="/user-blocked-data" className="dropdown-item">
                        User Blocked Data
                      </Link> */}

                      <div
                        className="dropdown-item venue-dropdown"
                        onMouseEnter={() => setVenueDropdownOpen(true)}
                        onMouseLeave={() => setVenueDropdownOpen(false)}
                      >
                        Venue Details ⬅
                        {isVenueDropdownOpen && (
                          <div className="sub-menu">
                            {" "}
                            {/* Now appears to the left */}
                            {locations.length > 0 ? (
                              locations.map((loc) => (
                                <Link
                                  key={loc.id}
                                  to={`/location/${loc.id}`}
                                  className="sub-menu-item"
                                >
                                  {loc.name}
                                </Link>
                              ))
                            ) : (
                              <div className="sub-menu-item">
                                No Locations Found
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                      <button className="dropdown-item" onClick={handleLogout}>
                        Logout
                      </button>
                    </>
                  )}

                  {userRole === "5" && (
                    <>
                      <Link to="/RIbookings" className="dropdown-item">
                        Booking list
                      </Link>
                      <Link to="/blocked-data" className="dropdown-item">
                        Blocked data
                      </Link>
                         <Link to="/Booked-Reports" className="dropdown-item">
                        Reports
                      </Link>

                      <button className="dropdown-item" onClick={handleLogout}>
                        Logout
                      </button>
                    </>
                  )}

                  {userRole === "6" && (
                    <>
                      {/* <Link to="/booked-reports" className="dropdown-item">
                        Reports
                      </Link> */}

                      <Link to="/CAOBookings" className="dropdown-item">
                        All Bookings
                      </Link>
                      <Link to="/blocked-data" className="dropdown-item">
                        Blocked data
                      </Link>
                        <Link to="/Booked-Reports" className="dropdown-item">
                     Reports
                      </Link>

                      <button className="dropdown-item" onClick={handleLogout}>
                        Logout
                      </button>
                    </>
                  )}

                  {userRole === "7" && (
                    <>
                      {/* <Link to="/booked-reports" className="dropdown-item">
                        Reports
                      </Link> */}

                      <Link to="/CAO-AO-bookings" className="dropdown-item">
                        All Bookings
                      </Link>
                      <Link to="/blocked-data" className="dropdown-item">
                        Blocked data
                      </Link>
                         <Link to="/Booked-Reports" className="dropdown-item">
                        Reports
                      </Link>

                      <button className="dropdown-item" onClick={handleLogout}>
                        Logout
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <Link to="/Login" className="login-button">
              Log In
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
